import { connect, MapDispatchToProps } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '~src/app/actions/spaces/ContentCountsActions';
import { selectContentCounts } from '~src/app/selectors/ContentCountsSelector';

import { CompositeSessionInfoSelectors } from '../app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../app/selectors/SiteUrlsSelectors';
import { AppState } from '../app/state/AppState';
import { MapStateToProps } from '../app/utils/ConnectUtils';
import { CatalogBrowserHostDispatchProps, ConnectedCatalogBrowserHostProps, WrappedCatalogBrowserHost } from './CatalogBrowserHost';

const mapStateToProps: MapStateToProps<ConnectedCatalogBrowserHostProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  assetCountResult: selectContentCounts<'catalog'>(state, 'catalog'),
});

const mapDispatchToProps: MapDispatchToProps<CatalogBrowserHostDispatchProps, ConnectedCatalogBrowserHostProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedAssetsCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedCatalogBrowserHost = connect(mapStateToProps, mapDispatchToProps)(WrappedCatalogBrowserHost);
